import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { SegmentedControl } from './SegmentedControl';
import { mockDataVolumeStore, type SalesDataSource } from '../../services/mock/mockDataVolume';

/**
 * SalesDataSourceToggle — the "Mock ↔ Real" data-source toggle for the Sales
 * Intelligence tab.
 *
 * Switches the Kanban feed between generated mock data (for density testing)
 * and live n8n-proxy data (campaign_metrics + leads_cards + get_lead).
 * localStorage-backed so the choice survives reloads. Only visible to
 * superadmin users (the caller gates visibility).
 */
export const SalesDataSourceToggle: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [source, setSourceState] = useState<SalesDataSource>(mockDataVolumeStore.getSource());

  useEffect(() => mockDataVolumeStore.subscribeSource(setSourceState), []);

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`.trim()}>
      <div className="inline-flex items-center gap-1.5 rounded-full border border-cyan-300/18 bg-cyan-400/8 px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-cyan-100 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
        <Icon icon="bx:data" className="h-3.5 w-3.5 text-cyan-200/90" />
        Data source
      </div>
      <SegmentedControl
        ariaLabel="Sales Intelligence data source"
        size="sm"
        tone="accent"
        value={source}
        onChange={(next) => mockDataVolumeStore.setSource(next as SalesDataSource)}
        options={[
          { value: 'mock', icon: 'bx:flask', label: 'Mock' },
          { value: 'real', icon: 'bx:cloud', label: 'Real' },
        ]}
      />
    </div>
  );
};

export default SalesDataSourceToggle;